import { render, staticRenderFns } from "./landing-guaymas.vue?vue&type=template&id=4feff882&scoped=true&"
import script from "./landing-guaymas.vue?vue&type=script&lang=js&"
export * from "./landing-guaymas.vue?vue&type=script&lang=js&"
import style0 from "./landing-guaymas.vue?vue&type=style&index=0&id=4feff882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feff882",
  null
  
)

export default component.exports